import { ModalPosition, ModalWidth } from '../types/type';
const ROW_HEIGHT_ITEM = 17;
const DETAIL_MODEL_HEIGHT = 251;
const MORE_MODEL_HEIGHT = 340;

// 详情弹窗调整
export const detailModalCaculate = (rect: DOMRect): ModalPosition => {
  // 如果距离右侧的距离小于弹窗宽度时
  let targetLeft = rect.left;
  let targetTop = rect.top - ROW_HEIGHT_ITEM;
  const distanceToRight = window.innerWidth - rect.right;
  // 右边界
  if (distanceToRight < ModalWidth) {
    targetLeft = rect.left - ModalWidth;
  } else {
    targetLeft = rect.left + rect.width;
  }

  // 下边界
  const distanceToBottom = window.innerHeight - rect.bottom;
  if (distanceToBottom < DETAIL_MODEL_HEIGHT) {
    targetTop = rect.top - DETAIL_MODEL_HEIGHT;
  } else {
    targetTop = rect.top;
  }

  return { top: targetTop, left: targetLeft };
};

// 更多弹窗调整
export const moreModalCaculate = (rect: DOMRect, itemLength: number): ModalPosition => {
  // 如果距离右侧的距离小于弹窗宽度时
  let targetLeft = rect.left;
  let targetTop = rect.top - ROW_HEIGHT_ITEM;
  // 计算弹窗高度
  let topModal = 48 + (itemLength * 28 < 290 ? itemLength * 28 : 290);
  // 下边界
  const distanceToBottom = window.innerHeight - rect.bottom;
  if (distanceToBottom < MORE_MODEL_HEIGHT) {
    // 需要把这个高度替换掉
    targetTop = rect.top - topModal;
  } else {
    targetTop = rect.top + ROW_HEIGHT_ITEM;
  }
  return { top: targetTop, left: targetLeft };
};
